import React from 'react';
import {
  chakra,
  Box,
  Img,
  LinkBox,
  Text,
  VStack,
  Checkbox,
  Image,
  RadioGroup,
  Stack,
  Radio,
  Spinner,
  Heading,
  useDisclosure,
  Textarea,
  Center,
  Highlight,
  Container,
  Badge,
  ButtonGroup,
  Button,
  Flex,
  HStack,
} from '@chakra-ui/react';
import BottomNavBar from 'components/BottomNavBar';
import { useLocation, useNavigate } from 'react-router-dom';
import Contact from '../../images/Vector.svg';
import { BsFillArrowRightCircleFill, BsFillArrowLeftCircleFill } from 'react-icons/bs';


function TermoEmergencia() {
  const navigate = useNavigate();
  const { state } = useLocation()
  const { atendimento } = state;
  console.log(state)
  return (
    <>
      <VStack
        align="center"
        justify={{
          base: 'center',
          md: 'space-around',
          xl: 'space-between',
        }}
        direction={{ base: 'column-reverse' }}
        wrap="no-wrap"
        minH="100vh"
        spacing={0}
        background="linear-gradient(180deg, #5AB2AE 0%, #EFA73F 28.65%, #5AB2AD 64.06%, #4E9E8F 100%);"
      >
        <Box as="card" width="328px" borderRadius="18px" fontSize="xs" size="10" backgroundColor="white" maxInlineSize="80" textAlign="center">
          <VStack m={{ sm: '10%' }} textColor="#585858">
            <Image top={{ lg: '5.5em', sm: '5em' }} src={Contact} alt="teste" height={'4.5em'} />

            <Text fontWeight="bold" fontSize="1.5em">
              Orientações da teleconsulta.
            </Text>

            <HStack backgroundColor="#E5E5E5" borderRadius="15px">
              <Text>
                <Flex ml="1em">
                  <Box backgroundColor="#5AB2AE" borderRadius="5px" margin="0.8em" color="rgba(62, 100, 255, 1)" padding="0 0.4em"></Box>
                  <Text margin="11% 0" fontSize="xs" align="center" color="#585858;">
                    <chakra.p fontWeight="bold">
                      Em casos de <b>emergências e urgências</b>, é recomendado tratamento médico presencial imediato;
                    </chakra.p>
                  </Text>
                </Flex>
                <Flex ml="1em">
                  <Box backgroundColor="#5AB2AE" borderRadius="5px" margin="0.8em" color="rgba(62, 100, 255, 1)" padding="0 0.4em"></Box>
                  <Text margin="11% 0" fontSize="xs" align="center" color="#585858;">
                    <chakra.p fontWeight="bold">
                      Se um <b>menor de idade</b> estiver em atendimento, é necessário que esteja acompanhado por um <b>adulto responsável</b>;
                    </chakra.p>
                  </Text>
                </Flex>
                <Flex ml="1em">
                  <Box backgroundColor="#5AB2AE" borderRadius="5px" margin="0.8em" color="rgba(62, 100, 255, 1)" padding="0 0.4em"></Box>
                  <Text margin="11% 0" fontSize="xs" align="center" color="#585858;">
                    <chakra.p fontWeight="bold">
                      Para sua <b>segurança</b>, seu atendimento será <b>gravado</b>.
                    </chakra.p>
                  </Text>
                </Flex>
              </Text>
            </HStack>
            <ButtonGroup pt="1rem" pb="3%" width="100%">
          <Button
            width="100%"
            colorScheme="teal"
            onClick={() => navigate('/telemedicina', { state: {atendimento}})} 
          >
            Continuar
          </Button>
        </ButtonGroup>
            <VStack w="100%" >
              <BsFillArrowLeftCircleFill size={'3em'} color="#5AB2AE" onClick={() => navigate(-1)} />
            </VStack>
           
          </VStack>
        </Box>
      </VStack>

      <BottomNavBar />
    </>
  );
}

export default TermoEmergencia;
